import { BrowserRouter } from "react-router-dom";
import Navigations from "./routes/navigations";

function App() {
    return (
        <>
            <div>
                <BrowserRouter>
                    <Navigations />
                </BrowserRouter>
            </div>
        </>
    );
}

export default App;